<div class="row p-2">

  <div class="text-explanation mt-5 col-lg-4 offset-lg-1 col-sm-4 offset-sm-0" [innerHTML]="'Texto' | translate"></div>

  <div class="form-body col-lg-5 col-sm-8">
    <form [formGroup]="frmCadastro" (ngSubmit)="onSubmit()">
      <div class="card border-0">
        <div class=" text-center">
          <h3>
            {{"TITULO CARD" | translate}}
          </h3>
        </div>
        <div class="card-body">
          <div class="row">

            <div class="col-md-{{frmField.columns ? frmField.columns : 12}}" *ngFor="let frmField of frmFieldList">
              <div class="mb-3">
                <label for="{{frmField.field}}" class="form-label">{{frmField.label | translate}}
                  <span class="text-danger" *ngIf="frmField.required">*</span>
                </label>
                <ng-container *ngIf="frmField.label == 'Descrição do relato'">
                  <textarea type="text" class="form-control" id="description" rows="10" [formControlName]="frmField.field"></textarea>
                </ng-container>
                <ng-container *ngIf="frmField.label != 'Descrição do relato' && frmField.type != 'select'">
                  <input [type]="frmField.type" class="form-control" [formControlName]="frmField.field" [id]="frmField.field">
                </ng-container>
                <ng-container *ngIf="frmField.type == 'select'">
                  <select class="form-control" [formControlName]="frmField.field">
                    <option value="">Selecione</option>
                    <option *ngFor="let opt of frmField.options" [value]="opt.value">
                      {{ opt.label }}
                    </option>
                  </select>
                </ng-container>

                <div class="alert alert-danger" *ngIf="frmField.required && f[frmField.field].invalid && (f[frmField.field].dirty || f[frmField.field].touched)">
                  {{frmField.label | translate}} {{ "obrigatorio" | translate}}
                </div>
              </div>
            </div>

            <div class="col-md-12">
              <div class="mb-3">
                <label for="name" class="form-label"> {{ "Anexar Arquivo" | translate }} </label>
                <app-file-upload #fileUpload></app-file-upload>
              </div>
            </div>

          </div>
        </div>
        <div class="card-footer text-center">
          <div class="row">
            <div class="col-md-10">
              <app-captcha #captcha></app-captcha>
            </div>
            <div class="col-md-2">
              <button type="submit" class="btn btn-primary" [disabled]="isClicked">{{"ENVIAR" | translate}}</button>
            </div>
          </div>
        </div>
      </div>

    </form>
  </div>
</div>
